import React from 'react';
import StatsCards from './StatsCards';
import { usePageTitle, usePageStats } from '../context/PageTitleContext';

const StandardPageHeader = ({
  title,
  stats = [],
  inlineStats = [],
  children
}) => {
  // Il titolo va nella navbar (DashboardLayout), non piu' nel corpo pagina
  usePageTitle(title);
  // inlineStats: contatori compatti in navbar a fianco del titolo, al posto delle StatsCards
  // (usarlo quando serve piu' spazio verticale per la tabella sotto)
  usePageStats(inlineStats);

  return (
    <>
      {stats.length > 0 && <StatsCards stats={stats} />}
      {children}
    </>
  );
};

export default StandardPageHeader;